import { OfficeLocation } from "../../../domain/backend";
import { ClientRegistrationForm } from "./types";

export const defaultForm: ClientRegistrationForm = {
  office: OfficeLocation.ST_LOUIS,
  advisor: { title: "", value: undefined },
  linkedClient: { title: "", value: undefined },
} as unknown as ClientRegistrationForm;
